export default "__VITE_ASSET__8363366b__"